import type { ParticipantDocument, ParticipantFile } from '@piccolohealth/pbs-common';

export type ParticipantFileOrDocument = ParticipantFile | ParticipantDocument;

export const isParticipantFile = (
  fileOrDocument: ParticipantFileOrDocument,
): fileOrDocument is ParticipantFile => {
  return (fileOrDocument as ParticipantFile).viewUrl !== undefined;
};
